import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAuth from '../../hooks/useAuth';
import { useNotifications } from '../../context/NotificationContext';
import logo from '../../assets/logo-full.png';

const HOME_FOR = { ADMIN: '/admin', APPROVER: '/review/bookings', TECHNICIAN: '/technician', CLIENT: '/client' };

export default function LoginPage() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const notify = useNotifications();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: '', password: '' });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await login(form.email.trim(), form.password);
      notify.success(t('auth.welcomeBack', { name: user.firstName }));
      const dest = location.state?.from?.pathname || HOME_FOR[user.role] || '/';
      navigate(dest, { replace: true });
    } catch (err) {
      notify.apiError(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page">
      <div className="auth-wrap">
        <div className="card pad">
          <div className="center" style={{ marginBottom: '1rem' }}>
            <img src={logo} alt="Talentech RDC" style={{ height: 72, margin: '0 auto .5rem' }} />
            <h2>{t('auth.loginTitle')}</h2>
            <p className="muted" style={{ fontSize: '.9rem' }}>{t('auth.loginSubtitle')}</p>
          </div>
          <form onSubmit={submit}>
            <div className="field">
              <label>{t('auth.email')}</label>
              <input type="email" required value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </div>
            <div className="field">
              <label>{t('auth.password')}</label>
              <input type="password" required value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })} />
            </div>
            <button className="btn block" disabled={busy}>
              {busy ? t('auth.signingIn') : t('auth.signIn')}
            </button>
          </form>
          <p className="muted center" style={{ marginTop: '1rem', fontSize: '.9rem' }}>
            {t('auth.noAccount')} <Link to="/register">{t('nav.signup')}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
